export default "/images/vendor/flag-icons/flags/4x3/pk.svg?e742c27f73142b4cff7fc3e547863a58";